"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIpData = getIpData;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

function getIpData(_x, _x2, _x3) {
  return _getIpData.apply(this, arguments);
}

function _getIpData() {
  _getIpData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(userId, publicReplyId, publicTopicId) {
    var _yield$axios$get, data;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get('/member/ip', {
              params: {
                yip_csrf_token: (0, _csrfToken.csrfToken)(),
                userid: userId,
                postid: publicReplyId !== null && publicReplyId !== void 0 ? publicReplyId : 0,
                topicid: publicTopicId !== null && publicTopicId !== void 0 ? publicTopicId : 0,
                json: true
              }
            });

          case 2:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getIpData.apply(this, arguments);
}